import React from 'react';

export const Separator: React.FC = () => <hr className="border-t border-mp-input my-4" />;
